export default __webpack_public_path__ + "assets/svg/SuspensionStrap.9c39d48e278f39df05ee0050d9969039.svg";